import React from 'react';
import { Layout, Dropdown, Menu, Button, Icon, message} from 'antd';
import common from "../assets/common.js";
import PassWordModal from './password/passwordmodal.js';
import BindModal from './bind/bindmodal.js';
const { Header } = Layout;


class Head extends React.Component {
  state = {
    userAdmin : {},
    modalType : "",
    modalData : {}
  }
  logout = () => {
    var postData = {};
    postData["_url"] = "admin/logout";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      message.info('退出成功');
      window.info = {};
      common.setCookie("info", "");
      obj.props.history.push('login');
    })
  }
  changeToSuper = () => {
    var postData = {};
    postData["_url"] = "admin/superAdmin/AdminToSuper";
    common.request(postData, this, function(obj, data){
      window.location.href = "index.html#/school";
      message.info("切换成功");
    });
  }
  showModal =(modalType, modalData) => {
    switch(modalType){
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  render() {
    const { modalType, modalData } = this.state;
    const collapsed = this.props.collapsed;
    const source = window.info ? window.info.source : {};
    
    const menu = (
      <Menu>
        <Menu.Item>
          <a onClick={ this.showModal.bind(this, "passWord") }>修改密码</a>
          {/* <Link to="/password"><a>修改密码</a></Link> */}
        </Menu.Item>
        { !window.info.switch && window.info.adminRoles !== "SUPER" && <Menu.Item>
          <a onClick={ this.showModal.bind(this, "bind") }>{window.info.openId ? "解绑支付宝" : "绑定支付宝" }</a>
        </Menu.Item>}
        <Menu.Item>
          <a onClick={ this.logout.bind(this) }>退出</a>
        </Menu.Item>
      </Menu>
    )
    const orgName = window.info ? window.info.orgName : "";
    const userName = window.info ? window.info.userName : "";
    return (
      <Header id="headDiv" className={ collapsed ? "collapsed hasHead" : "nocollapsed hasHead" }>
        <div className="headLeft pull-left">
          <Icon id="menuSwitch" className="cursor-pointer" type={ collapsed ? 'menu-unfold' : 'menu-fold'}  onClick={ this.props.changeCollapsed.bind(this, !collapsed) }/>
          <span className="headLeft-org ml-8">{ orgName }</span>
        </div>
        <div className="headRight pull-right">
          <div className="pull-left mr-16">
            { false && <Button className="swapBtn" onClick={ () => {
              window.open("/new/index.html#/overview")
            }}>
              <span>前往新版</span>
              <Icon type="swap" />
            </Button>}
            { window.info.switch && <Button onClick={ this.changeToSuper }><Icon type="arrow-left" />切换到超管</Button>}
          </div>
          {/*<div className="pull-left mr-8">
            <div id="headImg">
              <img src={ head } alt="" />
            </div>
          </div>*/}
          <div className="adminName">
            { !common.ifObjectEmpty(source) && <Button onClick={ this.returnTo }  size="small" title="回到超管"><Icon type="arrow-left" /></Button> }
            <Dropdown overlay={menu} trigger={[ "click" ]} getPopupContainer={() => document.getElementsByClassName('adminName')[0] }>
              <span className="cursor-pointer">
                <span>{ userName ? userName : orgName }</span>
                <Icon type="down" />
              </span>
            </Dropdown>
          </div>
        </div>
        <PassWordModal modalType={ modalType } modalData={ modalData } showModal={ this.showModal.bind(this) }/>
        <BindModal modalType={ modalType } modalData={ modalData } showModal={ this.showModal.bind(this) }/>
      </Header>
    )
  }
}
export default Head;



// WEBPACK FOOTER //
// ./src/index/head.js